import { register, getPrefix } from '../../../Utils'

// Timing configuration (all values in milliseconds).
const INITIAL_DELAY = 5000 // Delay before the toast first appears after page load.
const VISIBLE_DURATION = 7000 // How long the toast stays visible when the user does not interact.
const REAPPEAR_DELAY = 50000 // Delay before the toast reappears within the same session.
const MAX_SHOWS = 3 // Maximum number of times the toast is shown per session (total).

// Session storage keys.
const DISMISSED_KEY = 'ctaToastDismissed' // Set once the user actively interacts (close or CTA click).
const SHOW_COUNT_KEY = 'ctaToastShowCount' // Number of times the toast has been shown this session.

const readStorage = (key) => {
  try {
    return window.sessionStorage.getItem(key)
  } catch (e) {
    return null
  }
}

const writeStorage = (key, value) => {
  try {
    window.sessionStorage.setItem(key, value)
  } catch (e) {
    // Storage may be unavailable (e.g. private mode); fail silently.
  }
}

const CtaToast = el => {
  const prefix = getPrefix(el)
  const visibleClass = prefix + 'is--visible'
  const closeButton = el.querySelector('[data-cta-toast-close]')
  const ctaLink = el.querySelector('[data-cta-toast-cta] a')

  let showTimer = null
  let hideTimer = null

  const isDismissed = () => readStorage(DISMISSED_KEY) === '1'
  const getShowCount = () => parseInt(readStorage(SHOW_COUNT_KEY), 10) || 0

  const hide = () => {
    el.classList.remove(visibleClass)
    el.setAttribute('aria-hidden', 'true')
  }

  const scheduleNext = (delay) => {
    if (isDismissed() || getShowCount() >= MAX_SHOWS) {
      return
    }

    showTimer = window.setTimeout(show, delay)
  }

  const autoHide = () => {
    hide()
    scheduleNext(REAPPEAR_DELAY)
  }

  function show () {
    if (isDismissed() || getShowCount() >= MAX_SHOWS) {
      return
    }

    el.classList.add(visibleClass)
    el.setAttribute('aria-hidden', 'false')
    writeStorage(SHOW_COUNT_KEY, getShowCount() + 1)

    hideTimer = window.setTimeout(autoHide, VISIBLE_DURATION)
  }

  // Called when the user actively interacts: close it and never show it again this session.
  const dismiss = () => {
    writeStorage(DISMISSED_KEY, '1')
    window.clearTimeout(showTimer)
    window.clearTimeout(hideTimer)
    hide()
  }

  if (isDismissed()) {
    return
  }

  if (closeButton) {
    closeButton.addEventListener('click', dismiss)
  }

  if (ctaLink) {
    ctaLink.addEventListener('click', dismiss)
  }

  scheduleNext(INITIAL_DELAY)
}

register('CtaToast', CtaToast)
